module.exports = __webpack_public_path__ + "img/index_lou_icon_1.305a2899.png";